<template>
    <v-btn-toggle v-model="index" mandatory dense :class="`${$options.name}__ButtonSize`">
        <v-btn
            v-for="count in displayCount"
            :key="count"
            :ref="count"
            :disabled="isDisabled"
            text
            color="accent"
            class="pt-1"
        >
            {{ count }}
        </v-btn>
    </v-btn-toggle>
</template>

<script lang="ts">
import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator';
import type { PagingParam } from '../../utils/types/PagingParam';
import { shallowCopy } from '../../utils/types/utility';

@Component({
    name: 'PerPageSelector',
})
export default class PerPageSelector extends Vue {
    @Prop({ default: undefined }) readonly value?: PagingParam;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: () => [10, 20, 50, 100] }) readonly items: number[];

    @Emit()
    public input(value: PagingParam) {}

    get displayCount(): number[] {
        return this.items;
    }
    get index(): number {
        if (!this.value) {
            return 0;
        }
        return this.displayCount.indexOf(this.value.perPage);
    }
    set index(newIndex: number) {
        if (!this.value) {
            return;
        }
        let newValue = shallowCopy(this.value);
        if (newValue.perPage != this.displayCount[newIndex]) {
            newValue.currentPage = 1;
        }
        newValue.perPage = this.displayCount[newIndex];
        this.input(newValue);
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
}
</script>

<style lang="scss" scoped>
.PerPageSelector {
    &__ButtonSize {
        .v-btn.v-size--default {
            min-width: 2.5rem !important;
        }
    }
}
</style>
